import { Point } from '../../../math';
/** removes locks that don't change anything (applyLock gives the same point) */
export function normalizeLocks(locks, connectionStart) {
    if (!locks.length)
        return [];
    const hadX = locks.some((l) => l.axis === 'x');
    const hadY = locks.some((l) => l.axis === 'y');
    const out = [];
    let last = new Point(connectionStart.x, connectionStart.y);
    for (let i = 0; i < locks.length; i++) {
        const l = locks[i];
        const next = l.axis === 'x' ? new Point(l.value, last.y) : new Point(last.x, l.value);
        const isNoop = next.x === last.x && next.y === last.y;
        if (!isNoop) {
            out.push(l);
            last = next;
            continue;
        }
        // Keep a noop lock if it's the only representative of its axis,
        // to avoid changing the visual "shape" of the route after dragEnd.
        const hasSameAxisLater = locks.slice(i + 1).some((x) => x.axis === l.axis);
        const hasSameAxisAlready = out.some((x) => x.axis === l.axis);
        const shouldKeepNoop = (!hasSameAxisAlready && !hasSameAxisLater) || // this is the only lock of this axis
            false;
        if (shouldKeepNoop) {
            out.push(l);
            // last stays the same
        }
    }
    // Extra safety: preserve at least one lock per axis that existed before
    if (hadX && !out.some((l) => l.axis === 'x')) {
        const firstX = locks.find((l) => l.axis === 'x');
        if (firstX)
            out.push(firstX);
    }
    if (hadY && !out.some((l) => l.axis === 'y')) {
        const firstY = locks.find((l) => l.axis === 'y');
        if (firstY)
            out.unshift(firstY);
    }
    return out;
}
